export default __webpack_public_path__ + "static/media/inactive-group-icon.a149a367.svg";